<template>
  <div class="CurriculumSetMeal sw-container">
    <div class="common-nav">
      <span class="s1">您的位置</span>
      <span class="s2">|</span>
      <span class="s3">选课中心</span>
    </div>
    <div class="CurriculumSetMeal-nav">
      <div class="CurriculumSetMeal-nav-item">
        <span class="CurriculumSetMeal-nav-label">年限分类</span>
        <RadioGroup
            class="CurriculumSetMeal-nav-radio"
            v-model="year"
            type="button"
            @on-change="getData"
        >
          <Radio label="全部"></Radio>
          <template v-for="i in typeData">
            <Radio :label="i.name"></Radio>
          </template>
        </RadioGroup>
      </div>
    </div>
    <div
        v-if="dataInfo.length <= 0"
        class="noData"
        style="height:450px; text-align:center;line-height:450px;background:#fff"
    >
      暂无数据
    </div>
    <div v-else style="min-height:450px;">
      <template v-for="i in dataInfo">
        <div class="CurriculumSetMeal-item" @click="goInfo(i.id)">
          <img class="CurriculumSetMeal-img" :src="i.imgUrl"/>
          <div class="CurriculumSetMeal-font">
            <div class="CurriculumSetMeal-p1">
              <span class="CurriculumSetMeal-name">{{ i.name }}</span>
              <span class="CurriculumSetMeal-money">￥ {{ i.money }}</span>
            </div>
            <div class="CurriculumSetMeal-p2">购买学时,享受更多服务</div>
            <div class="CurriculumSetMeal-btn" @click.stop="goPay(i.id)">
              点击购买
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="CurriculumSetMeal-page">
      <Page
          v-if="totalPage > 0"
          :total="totalPage"
          show-elevator
          show-total
          :current="pageIndex"
          class-name="pageItem"
          @on-change="handleChangePage"
      >
      </Page>
    </div>
  </div>
</template>

<script>
import * as api from "@/assets/api/api.js";
import {Message} from "view-design";
import {postDataJxjy} from "@/assets/api/api.js";

export default {
  name: "CurriculumSetMeal",
  components: {},
  data() {
    return {
      totalPage: 0,
      dataInfo: [],
      typeData: {
        years: [],
      },
      year: "全部",
      pageIndex: 1,
    };
  },
  created() {
    this.getData();
    this.getDataType();
    api.EventBus.$emit("changeNav", 1);
    //弹窗
    if (!this.$store.state.master.user.phone) {
      this.$router.push({
        path: "/bindPhone",
      });
    }

  },
  computed: {
    userInfo() {
      return this.$store.state.userStudyInfo;
    },
  },
  methods: {
    // loadUserInfo() {
    //   this.$store.dispatch("getUserStudyInfo");
    // },
    getData() {
      api.showLoading();
      let year;
      if (this.year == "全部") {
        year = "";
      } else {
        for (let i of this.typeData) {
          if (i.name == this.year) {
            year = i.id;
          }
        }
      }
      postDataJxjy("/jxjyapi/tenpoint/getCourse").then(res => {
        console.log(res.data);
        if(res.code == 1){
          this.dataInfo = res.data;
          this.totalPage = res.total;
        }
      })


      // api.postData("sale/comboList", {
      //       yearId: year,
      //       pageSize: 10,
      //       currentPage: this.pageIndex - 1,
      //     })
      //     .then((res) => {
      //       this.dataInfo = res.data;
      //       this.totalPage = res.total;
      //     });
    },
    getDataType() {
      api.showLoading();
      api.postData("sale/comboYearList", {}).then((res) => {
        this.typeData = res.data;
      });
    },
    goInfo(id) {
      this.$router.push({
        path: "/CurriculumSetMealInfo",
        query: {
          cid: id,
        },
      });
    },
    goPay(id) {
      this.$router.push({
        path: "/OrderOk",
        query: {
          cid: id,
        },
      });
    },
    handleChangePage(i) {
      this.pageIndex = i;
      this.getData();
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.CurriculumSetMeal {
  &-item {
    background: #fff;
    display: flex;
    padding: 20px 30px 20px 20px;
    margin-bottom: 12px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
  }

  &-item:hover {
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    border-color: #eee;
  }

  &-img {
    width: 200px;
    height: 120px;
    margin-right: 30px;
  }

  &-font {
    flex: 1;
  }

  &-p1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-name {
    color: #222222;
    font-size: 18px;
  }

  &-money {
    color: #ec6941;
    font-size: 30px;
    font-weight: bold;
  }

  &-p2 {
    color: #999999;
    font-size: 14px;
  }

  &-btn {
    width: 100px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    color: #fff;
    margin-top: 30px;
    background: #ec6941;
    border-radius: 3px;
    cursor: pointer;
  }

  &-btn:hover {
    background: rgba(236, 105, 65, 0.8);
  }

  &-page {
    text-align: center;
    margin-bottom: 20px;
  }

  &-nav {
    border-top: 1px solid #f0f1f4;
    padding: 20px 30px;

    &-f {
      padding-top: 190px;
    }

    &-top {
      position: fixed;
      top: 0;
      z-index: 10;
      background: #fff;
      width: 1200px;
      left: 50%;
      margin-left: -600px;
      padding: 20px 30px;
      border-bottom: 2px solid #eee;
    }

    &-item {
      display: flex;
      margin-bottom: 14px;
    }

    &-radio {
      flex: 1;
    }

    &-label {
      color: #333333;
      font-size: 14px;
      margin-right: 26px;
      line-height: 32px;
    }

    .ivu-radio-group-button .ivu-radio-wrapper {
      margin-right: 10px;
      border: none;
      box-shadow: none;
      font-size: 14px;
      background: none;
    }

    .ivu-radio-group-button .ivu-radio-wrapper:after,
    .ivu-radio-group-button .ivu-radio-wrapper:before {
      width: 0;
    }

    .ivu-radio-group-button .ivu-radio-wrapper-checked {
      background: #ec6941;
      color: #fff;
      border-radius: 5px;
    }

    tbody .Curriculum-ztm {
      text-align: left;
    }
  }
}
</style>
